export const ValidateCampaignReferral = "a1d5a65675c872bd2c645b8fce26951830cd24dab93286a582dd7effe29df991";